<template>
  <div class="featured-dorms__list dorm-card__list user__list-wrp">
    <container>
      <div class="result-bracket__title user__list-count">
        <span class="result-bracket__count">{{ favorites.length }} </span> Favori Yurt Bulunuyor!
      </div>
      <row>
        <div
          v-for="dorm in favorites"
          :key="dorm.id"
          class="featured-dorms__col col-xl-4 col-lg-4 col-md-4 user__list">
          <dorm-card
            :dorm="dorm"
          />
        </div>
      </row>
    </container>
  </div>
</template>
<script>
import DormCard from '@/components/DormCard'
import axios from 'axios'
export default {
  name: 'UserFavorites',
  components: {
    DormCard
  },
  metaInfo () {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: 'Favorilerim',
      link: [
        { rel: 'canonical' },
        { href: window.location.origin + '/kullanici-yonetimi/favorilerim' }
      ]
    }
  },
  data () {
    return {
      favorites: [],
      errors: []
    }
  },
  methods: {
    getFavorites () {
      let self = this
      axios.get(`/user/favorites`)
        .then(response => {
          self.favorites = response.data.favorites
        })
        .catch(e => {
          self.errors.push(e)
        })
    }
  },
  mounted () {
    this.getFavorites()
  }
}
</script>

<style lang="scss">

</style>
